import TicketQueueList from "./list";


if (document.body.getAttribute("data-current-path") === "ticket/queues") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new TicketQueueList();
    }
}